var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoConnection = function SvgNoConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15300_78339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15259 7.14648H2.58203",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8457 12.8535H17.4163",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14648 3.1543V2.58374",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8535 16.8474V17.418",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32216 4.32227L3.91992 3.91882",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6777 15.6766L16.08 16.0801",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78988 9.59719C9.00384 9.3832 9.12365 9.09293 9.12365 8.79031C9.12365 8.48768 9.00384 8.19744 8.78988 7.98342C8.57592 7.76946 8.28494 7.64922 7.98256 7.64922C7.68015 7.64922 7.38917 7.76946 7.17521 7.98342C6.4706 8.6875 5.56055 9.59719 5.56055 9.59719L7.17521 11.2109C7.17521 11.2109 8.08526 10.3012 8.78988 9.59719Z",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0174 12.8238C12.2314 12.6098 12.3512 12.3195 12.3512 12.0169C12.3512 11.7142 12.2314 11.424 12.0174 11.21C11.8035 10.996 11.5125 10.8758 11.2101 10.8758C10.9077 10.8758 10.6168 10.996 10.4028 11.21C9.70099 11.9141 8.79102 12.8238 8.79102 12.8238L10.4028 14.4375C10.4028 14.4375 11.3128 13.5278 12.0174 12.8238Z",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8078 14.8408L5.15943 9.19269C5.15943 9.19269 4.60027 9.75092 3.94984 10.403C2.83443 11.5171 2.83443 13.3234 3.94984 14.4374C4.47477 14.9618 5.03958 15.5267 5.56163 16.0512C6.67708 17.1652 8.48287 17.1652 9.59828 16.0512C10.2487 15.399 10.8078 14.8408 10.8078 14.8408Z",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8418 10.8066L9.19336 5.15849C9.19336 5.15849 9.75249 4.60028 10.4029 3.94819C11.5183 2.83409 13.3241 2.83409 14.4396 3.94819C14.9616 4.47255 15.5264 5.03754 16.0513 5.56193C17.1668 6.67599 17.1668 8.48224 16.0513 9.59631C15.4009 10.2484 14.8418 10.8066 14.8418 10.8066Z",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56076 16.052L3.94897 14.4382L1.44141 16.9449L3.05607 18.5586L5.56076 16.052Z",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5588 3.05586L16.9441 1.44212L14.4395 3.94879L16.0512 5.5625L18.5588 3.05586Z",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15300_78339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgNoConnection;